import { useState, useEffect } from 'react';
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Hook for fetching a user's payment transactions (incoming + outgoing)
 */
export const useMyPayments = (uid) => {
  const [outgoing, setOutgoing] = useState([]);
  const [incoming, setIncoming] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid) {
      setOutgoing([]);
      setIncoming([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    let outgoingLoaded = false;
    let incomingLoaded = false;

    const checkDone = () => {
      if (outgoingLoaded && incomingLoaded) setLoading(false);
    };

    // Outgoing payments (user is the payer / bounty owner)
    const outQ = query(
      collection(db, 'transactions'),
      where('fromUid', '==', uid),
      orderBy('createdAt', 'desc')
    );

    const unsubOut = onSnapshot(outQ, (snap) => {
      setOutgoing(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      outgoingLoaded = true;
      checkDone();
    });

    // Incoming payments (user is the researcher / payee)
    const inQ = query(
      collection(db, 'transactions'),
      where('toUid', '==', uid),
      orderBy('createdAt', 'desc')
    );

    const unsubIn = onSnapshot(inQ, (snap) => {
      setIncoming(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      incomingLoaded = true;
      checkDone();
    });

    return () => {
      unsubOut();
      unsubIn();
    };
  }, [uid]);

  return { outgoing, incoming, loading };
};
